import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { SaleInquiriesListAction } from "../../Redux/Actions/OrganizationAction";
import ReactCountryFlag from "react-country-flag";
import { Pagination, Stack, Tooltip } from "@mui/material";
import { getCountryCodeByName } from "../../utils/Helper";
import { S3MediaURL } from "../../Config/Config";
import {
  formatDate,
  calculateTotalPages,
  toCamelCase,
} from "../../utils/Helper";

const SaleInquiry = () => {
  const dispatch = useDispatch<any>();
  const [count, setcount]: any = useState(0);
  const [loading, setLoading]: any = useState(false);
  const [saleinquiry, setsaleinquiry] = useState([]);
  let SaleInquiriesListData = useSelector(
    (state: any) => state.SaleInquiriesListData
  );
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);

  useEffect(() => {
    const params = `?page=${page}&page_size=${rowsPerPage}`;
    dispatch(SaleInquiriesListAction(params));
  }, [dispatch, page, rowsPerPage]);

  useEffect(() => {
    if (SaleInquiriesListData?.data?.row) {
      setsaleinquiry(() => SaleInquiriesListData?.data?.row);
      setcount(() => SaleInquiriesListData?.data?.total_count);
    }
  }, [SaleInquiriesListData]);

  return (
    <>
      <div className="page-wrapper card" style={{ display: "block" }}>
        <Breadcrumb
          pageTitle="Organizations"
          breadcrumbs={[
            {
              label: "HelpnSupport",
              path: "/support_requests/queries",
              isActive: false,
            },
            {
              label: "Queries",
              path: "/support_requests/queries",
              isActive: true,
            },
          ]}
        />

        <div className="container-fluid mt-5">
          <div className="card">
            <div className="table-responsive">
              <table className="table">
                <thead className="table-dark">
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Email</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Modified At</th>
                  </tr>
                </thead>
                <tbody>
                  {saleinquiry?.length > 0
                    ? saleinquiry?.map(
                        (saleinquiry: any, saleinquirykey: any) => {
                          return (
                            <Fragment key={saleinquirykey}>
                              <tr>
                                <th scope="row">
                                  {(page - 1) * rowsPerPage +
                                    saleinquirykey +
                                    1}
                                </th>
                                <td>{saleinquiry?.email}</td>

                                <td>{formatDate(saleinquiry?.created_at)}</td>

                                <td>{formatDate(saleinquiry?.modified_at)}</td>
                              </tr>
                            </Fragment>
                          );
                        }
                      )
                    : ""}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination-style">
            <Stack spacing={2}>
              <Pagination
                count={calculateTotalPages(count, rowsPerPage)}
                color="primary"
                variant="outlined"
                shape="rounded"
                page={page}
                onChange={(e: any, newPage) => setPage(newPage)}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleInquiry;
